import {useState, useEffect} from 'react';
import {getPurchaseOrders} from "../../api/Api";
import {ExistingPurchaseOrderTable} from "./ExistingPurchaseOrderTable";
import {PurchaseOrderStatusType} from "../../api/Constants";

export const ExistingPurchaseOrder = ({onApiFail, refresh, onRefresh,  props}) => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    useEffect(() => {
        getPurchaseOrders(PurchaseOrderStatusType.Complete, false).then(r => {
            setPurchaseOrders(r);
        }).catch(e => {

        })
    }, [onApiFail, refresh])


    const content = <ExistingPurchaseOrderTable items={purchaseOrders}  onRefresh={onRefresh} onApiFail={onApiFail}/>

    return content;
}